import Appsignal from '@appsignal/javascript'

const appsignal = new Appsignal({
  key: process.env.VUE_APP_APPSIGNAL_FRONTEND_API_KEY,
})

export default appsignal
